import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { faq } from "../../data/faq";
import { IconMinus, IconPlus } from "../Icon";
import { Reveal } from "../motion/Reveal";

export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="section bg-surface-soft">
      <div className="container-page max-w-4xl">
        <Reveal as="header" className="max-w-2xl">
          <span className="eyebrow">Questions fréquentes</span>
          <h2 className="mt-4">Tout savoir avant de faire appel à un agent d'entretien à Vichy</h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-10 rounded-2xl bg-white border border-slate-200 shadow-soft divide-y divide-slate-100 overflow-hidden">
          {faq.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  className="w-full flex items-center gap-4 px-5 sm:px-6 py-5 text-left cursor-pointer group"
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${i}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                >
                  <span className="flex-1 font-display font-semibold text-brand-900 text-base sm:text-lg">
                    {item.q}
                  </span>
                  <motion.span
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
                    className="grid h-9 w-9 place-items-center rounded-full bg-brand-50 text-brand-700 flex-none group-hover:bg-brand-100 transition-colors"
                  >
                    {isOpen ? <IconMinus className="h-4 w-4" /> : <IconPlus className="h-4 w-4" />}
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      id={`faq-panel-${i}`}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                      style={{ overflow: "hidden" }}
                    >
                      <div className="px-5 sm:px-6 pb-5 text-ink-muted leading-relaxed">
                        {item.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </Reveal>
      </div>
    </section>
  );
}
